import { formatCurrency, formatNumber, formatPercentage } from '@urbanx/agx-ui-components';
import { KeyMetricMetricType } from '@urbanx/agx.rex.client';

const formatMetricsValue = (
  value: number,
  type: KeyMetricMetricType,
  decimalPlacesForPercentage?: number
) => {
  if (value === null || value === undefined || value === 0) {
    return '';
  }

  switch (type) {
    case KeyMetricMetricType.WholeNumber:
      return formatNumber(value.toString(), 0);
    case KeyMetricMetricType.Currency:
      return formatCurrency(value, 0);
    case KeyMetricMetricType.Percentage:
      return formatPercentage(value.toString(), decimalPlacesForPercentage || 0);
    default:
      return value.toLocaleString();
  }
};

export default formatMetricsValue;
